<template>
  <div v-show="show" class="footer-container" :style="{'background-color': bgColor, 'color': color}">
    <div class="footer-me">
      <div class="footer-copyright">Copyright © 2005-2021 {{ $t("footer.copyright") }} <a class="miit-info" href="https://beian.miit.gov.cn" target="_blank">{{ $t("footer.miit") }}</a>  V{{version.master}}.{{version.branch}}.{{version.item}}</div>
    </div>
  </div>
</template>

<script>
const version = require('@/utils/version.json')

export default {
  data () {
    return {
      version
    }
  },
  props: {
    show: false
  },
  computed: {
    bgColor () {
      return this.$route.name === 'home' ||
      this.$route.name === 'signup' ||
      this.$route.name === 'signin' ||
      this.$route.name === 'forgot' ||
      this.$route.name === 'delete' ? 'transparent' : '#2F3345'
    },
    color () {
      return this.$route.name === 'signup' ||
      this.$route.name === 'signin' ||
      this.$route.name === 'forgot' ||
      this.$route.name === 'delete' ? '#666' : '#fff'
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-container{
  position: relative;
  width: 100%;
  height: 60px;
  background-color: #2F3345;
}
.footer-me{
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}
.footer-copyright{
  font-size: 14px;
  .miit-info {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue